import React from 'react'
import { Container } from './styles'
import { ButtonSize } from './types'

export interface ButtonBaseProps
  extends React.ComponentProps<typeof Container> {
  size?: ButtonSize
  variant?: 'contained' | 'outlined'
  disabled?: boolean
  type?: 'button' | 'reset' | 'submit'
  loading?: boolean
}

export const ButtonBase = ({
  size = 'large',
  variant,
  disabled = false,
  type = 'button',
  loading,
  ...rest
}: ButtonBaseProps) => (
  <Container
    disabled={disabled || loading}
    size={size}
    type={type}
    variant={variant}
    {...rest}
  />
)
